export default __webpack_public_path__ + "static/media/marcelo.566eeca4.jpg";